var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.30719V10.2505L10 16.2505L0 10.2514V8.30802L10 14.308L20 8.30802V8.30719ZM19.9533 6.52635L10 0.554688L0.0466667 6.52635L10 12.498L19.9533 6.52635ZM0 11.9172V13.8605L10 19.8605L11.6667 18.8605V16.9172L10 17.9172L0 11.9172ZM17.5 13.8347H15.8333V16.3347H13.3333V18.0014H15.8333V20.5014H17.5V18.0014H20V16.3347H17.5V13.8347Z",
    fill: "#18BB0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrad);
export default __webpack_public_path__ + "static/media/grad.e9330b9d72d73a1606ec7d5f949843c9.svg";
export { ForwardRef as ReactComponent };